import { gql } from "apollo-boost";
import {STUDENT_NAME_FIELDS, TEACHER_NAME_FIELDS} from '@/queries/fragments/name-fields';

export const GET_STUDENTENROLL = gql`
  query getStudentEnroll($id: ID!) {
    getStudentEnroll(
      id: $id
    ) {
      id enrollNo periodCode studentCode enrollDate
      totalCredit totalDropCredit source
      academicPeriod{
        id periodCode
      }
      student {
        ...StudentNameFields
      }
      studentEnrollDetails{
        id sectionNo subjectCode teacherCode credit
        learnSpanNo examSpanNo isDrop
        courseOutlineRegistration{
          id
        }
        classSection{
          id studentRegisterQty studentQty
        }
        subject{
          id code nameLocal nameEng
        }
        teacher {
          ...TeacherNameFields
          picturePath
        }

      }

    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const GET_STUDENTENROLLS = gql`
  query getStudentEnrolls {
    getStudentEnrolls {
      id
      enrollNo
      academicPeriod {
        id
      }
      periodCode
      student {
        ...StudentNameFields
      }
      studentCode
      enrollDate
      totalCredit
      totalDropCredit
      source
    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const GET_STUDENTENROLL_BY_FILTER = gql`
  query getStudentEnrollsByFilter(
    $studentEnrollFilterInput: StudentEnrollFilterInput!
  ) {
    getStudentEnrollsByFilter(
        studentEnrollFilterInput: $studentEnrollFilterInput
    ) {
      id enrollNo
      academicPeriod { id }
      periodCode
      student {
        ...StudentNameFields
        degree {
          id
          code
          nameLocal
          nameEng
        }
        curriculum {
          id
          code
          nameLocal
          nameEng
        }
        faculty {
          id
          code
          nameLocal
          nameEng
        }
        department {
          id
          code
          nameLocal
          nameEng
        }
      }
      studentCode
      enrollDate
      totalCredit
      totalDropCredit
      studentEnrollDetails{
        id sectionNo subjectCode teacherCode
        credit learnSpanNo examSpanNo isDrop
        subject{
          id nameLocal nameEng
        }
        teacher {
          ...TeacherNameFields
          picturePath
        }
        classSection{
          id studentRegisterQty studentQty
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const ADD_STUDENTENROLL = gql`
  mutation addStudentEnroll(
    $studentEnrollInput: StudentEnrollInput!,
    $academicPeriodId: String!,
    $studentId: String!
    $studentEnrollDetailArrayInput: [StudentEnrollDetailArrayInput]
  ) {
    addStudentEnroll (
      studentEnrollInput: $studentEnrollInput
      academicPeriodId: $academicPeriodId,
      studentId: $studentId
      studentEnrollDetailArrayInput: $studentEnrollDetailArrayInput
    )
    {id enrollNo periodCode studentCode enrollDate
      totalCredit totalDropCredit source
      academicPeriod{
        id periodCode
      }
      student {
        ...StudentNameFields
      }
      studentEnrollDetails{
        id sectionNo subjectCode teacherCode credit
        learnSpanNo examSpanNo isDrop
        courseOutlineRegistration{
          id
        }
        classSection{
          id studentRegisterQty studentQty
        }
        subject{
          id code nameLocal nameEng
        }
        teacher {
          ...TeacherNameFields
          picturePath
        }

      }

    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const ADD_STUDENTENROLLS_UPLOAD = gql`
  mutation addStudentEnrollsUpload(
    $studentEnrollsUploadInput: [StudentEnrollsUploadInput]
  ) {
    addStudentEnrollsUpload (
      studentEnrollsUploadInput: $studentEnrollsUploadInput,
    )
    {
      successCount
      failCount
      resultAddStudentEnrollUpload{
        no periodCode studentCode studentName subjectCode sectionNo learnSpanNo isDrop status remark
      }
    }
  }
`;

export const ADD_STUDENTENROLL_WITH_STUDENTENROLLDETAILS = gql`
  mutation addStudentEnrollWithStudentEnrollDetails(
    $studentEnrollInput: StudentEnrollInput!
    $studentId: String!
    $academicPeriodId: String!
    $subjects: [String]!
  ) {
    addStudentEnrollWithStudentEnrollDetails (
      academicPeriodId: $academicPeriodId,
      studentId: $studentId,
      studentEnrollInput: $studentEnrollInput,
      subjects: $subjects
    )
      {
        studentEnrollDetails {
          success
          error
          message
        }
        result {
          success
          error
          code
          message
          subjectId
        }
      }
  }
`;

export const UPDATE_STUDENTENROLL = gql`
  mutation updateStudentEnroll(
    $id: ID!,
    $studentEnrollInput: StudentEnrollInput!
  ) {
    updateStudentEnroll (
      id: $id
      studentEnrollInput: $studentEnrollInput
    ) {
      id
    }
  }
`;

export const DELETE_STUDENTENROLL = gql`
  mutation deleteStudentEnroll(
    $id: ID!
  ) {
    deleteStudentEnroll (
      id: $id
    ) {
      id
    }
  }
`;

export const UPLOAD_STUDENTENROLL_SPREADSHEET = gql`
  mutation uploadStudentEnrollSpreadsheet(
    $file: Upload!
  ) {
    uploadStudentEnrollSpreadsheet (
      file: $file
    ) {
      filename
    }
  }
`;

